import React from 'react';

const ErrorMessage = ({ message }) => (
  <>{ !!message && <div className="red low-base-size">{ message }</div> }</>
);

export default ErrorMessage;
